import Back from "../../assets/img/icons/back_new.svg";
import { ArrowBox, BackLinkSection, CommonText } from "../../styledComponents/common";


const BackButtonComponent = props => (
  <BackLinkSection onClick={props.onClick} gap={props.gap}>
    <ArrowBox size={props.size}>
      <img src={Back} alt="back" width="100%" />
    </ArrowBox>
    <CommonText
      fontWeight="500"
      color="#3C4D4B"
      fontSize={props.font ? props.font : "14px"}
    >
      {props.subTitle}
    </CommonText>
  </BackLinkSection>
);

export default BackButtonComponent;